export default __webpack_public_path__ + "static/media/PUservice.c4cf606d.jpg";